"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _constants = require("../constants");

var _Utils = _interopRequireDefault(require("../common/util/Utils"));

var _sflyMenuOn = _interopRequireDefault(require("@sfly/uig-svg-icon/logos/shutterfly/sfly-menu-on"));

var _sflyMenuOff = _interopRequireDefault(require("@sfly/uig-svg-icon/logos/shutterfly/sfly-menu-off"));

var _tpMenuOn = _interopRequireDefault(require("@sfly/uig-svg-icon/logos/tinyprints/tp-menu-on"));

var _tpMenuOff = _interopRequireDefault(require("@sfly/uig-svg-icon/logos/tinyprints/tp-menu-off"));

var _react = _interopRequireDefault(require("react"));

var getLogoData = function getLogoData() {
  var envPrefix = _Utils.default.getEnvPrefix();

  var logos = [{
    key: _constants.BRANDS.SHUTTERFLY,
    logo: {
      selected: {
        svg: _react.default.createElement(_sflyMenuOn.default, {
          alt: 'Go to the Shutterfly home page.'
        }),
        imgUrl: 'https://cdn.staticsfly.com/img_/ui/sitenav/imgsfly_on@2x-v14779502040006276.png'
      },
      unSelected: {
        svg: _react.default.createElement(_sflyMenuOff.default, {
          alt: 'Go to the Shutterfly home page.'
        }),
        imgUrl: 'https://cdn.staticsfly.com/img_/ui/sitenav/imgsfly_off@2x-v14866789480006998.png'
      }
    },
    link: "//www.".concat(envPrefix, "shutterfly.com"),
    hideOn: ['mobile', 'desktop'],
    attr: {
      alt: 'Go to the Shutterfly home page.',
      title: 'Go to the Shutterfly home page',
      'aria-label': 'Shutterfly',
      'data-link-id': 'sfly_logo',
      'data-link-module': 'global-header',
      'data-link-module-type': 'top-nav',
      'data-link-module-position': 'none',
      'data-link-position': '0'
    }
  }, {
    key: _constants.BRANDS.TINYPRINTS,
    logo: {
      selected: {
        svg: _react.default.createElement(_tpMenuOn.default, {
          alt: 'Go to the Tinyprints home page.'
        }),
        imgUrl: 'https://cdn.staticsfly.com/img_/ui/sitenav/imgtp_on@2x-v14866789480006601.png'
      },
      unSelected: {
        svg: _react.default.createElement(_tpMenuOff.default, {
          alt: 'Go to the Tinyprints home page.'
        }),
        imgUrl: 'https://cdn.staticsfly.com/img_/ui/sitenav/imgtp_off@2x-v14866789480006898.png'
      }
    },
    link: "//www.".concat(envPrefix, "tinyprints.com"),
    hideOn: ['mobile', 'desktop'],
    attr: {
      alt: 'Go to the Tinyprints home page.',
      title: 'Go to the Tinyprints home page.',
      'aria-label': 'Tinyprints',
      'data-link-id': 'tp_logo',
      'data-link-module': 'global-header',
      'data-link-module-type': 'top-nav',
      'data-link-module-position': 'none',
      'data-link-position': '0'
    }
  }];
  return logos;
};

var _default = getLogoData;
exports.default = _default;